import { CLEAR_LIKES, UPDATE_LIKES, UPDATING_LIKED, SET_LIKED } from "../reducers/actiontypes";
import { addErrors, clearErrors } from "./ui";
import { logEvent } from "../util";

export let clearLikes = function() {
	return {
		type: CLEAR_LIKES
	};
}

export let updateLikes = function(likes, liked) {
	return {
		type: UPDATE_LIKES,
		likes: likes,
		liked: liked
	};
}

export let fetchLikes = function() {
	return function(dispatch, getState) {
		var instance = getState().instances.current;

		dispatch(clearLikes());

		window.getLikes(instance, function(err, data){
			if (!err) {
				dispatch(updateLikes(data.likes, data.liked));
			}
		});
	};
};

export let setUpdatingLiked = function() {
	return {
		type: UPDATING_LIKED
	};
}

export let setLiked = function(liked) {
	return {
		type: SET_LIKED,
		liked: liked
	};
}

export let saveLiked = function(liked) {
	return function(dispatch, getState) {
		var state = getState(),
			instance = state.instances.current,
			current_value = state.likes.liked;

		dispatch(setUpdatingLiked());
		dispatch(clearErrors());

		window.onSaveLiked(liked, instance, function(err) {
			if (err) {
				dispatch(addErrors(err.map(function(e){ return e.message; })));
				dispatch(setLiked(current_value));
			}
			else {
				dispatch(setLiked(liked));
				logEvent({ event: liked?'like':'unlike' });
			}
		});
	}
}

export let toggleLiked = function() {
	return function(dispatch, getState) {
		var liked = getState().likes.liked;

		dispatch(saveLiked(!liked));
	}
}